/** Built-in gradient placeholders used until real playbook artwork is available. */
export type PlaybookGradient =
  | 'default'
  | 'academic'
  | 'sales'
  | 'onboarding'
  | 'presentation';

export const GRADIENT_PRESETS: Record<PlaybookGradient, string> = {
  default:
    'radial-gradient(circle at 75% 110%, rgba(20,184,166,0.45) 0%, transparent 50%),' +
    'radial-gradient(circle at 60% 30%, rgba(255,255,255,0.45) 0%, transparent 40%),' +
    'radial-gradient(circle at 88% 20%, rgba(20,184,166,0.25) 0%, transparent 30%),' +
    'linear-gradient(135deg, #e0faf5 0%, #ccfbf1 100%)',
  academic:
    'radial-gradient(circle at 20% 110%, rgba(59,130,246,0.4) 0%, transparent 50%),' +
    'radial-gradient(circle at 65% 25%, rgba(255,255,255,0.45) 0%, transparent 40%),' +
    'radial-gradient(circle at 85% 15%, rgba(59,130,246,0.2) 0%, transparent 30%),' +
    'linear-gradient(135deg, #e0eeff 0%, #ccdbff 100%)',
  sales:
    'radial-gradient(circle at 80% 110%, rgba(245,158,11,0.4) 0%, transparent 50%),' +
    'radial-gradient(circle at 55% 30%, rgba(255,255,255,0.45) 0%, transparent 40%),' +
    'radial-gradient(circle at 85% 15%, rgba(245,158,11,0.2) 0%, transparent 30%),' +
    'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
  onboarding:
    'radial-gradient(circle at 70% 110%, rgba(16,185,129,0.4) 0%, transparent 50%),' +
    'radial-gradient(circle at 60% 28%, rgba(255,255,255,0.45) 0%, transparent 40%),' +
    'radial-gradient(circle at 88% 18%, rgba(16,185,129,0.2) 0%, transparent 30%),' +
    'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
  presentation:
    'radial-gradient(circle at 70% 110%, rgba(168,85,247,0.4) 0%, transparent 50%),' +
    'radial-gradient(circle at 60% 28%, rgba(255,255,255,0.45) 0%, transparent 40%),' +
    'radial-gradient(circle at 88% 18%, rgba(168,85,247,0.2) 0%, transparent 30%),' +
    'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)',
};

/** Preset keys in display order — handy for cycling through placeholder variety. */
export const GRADIENT_KEYS = Object.keys(GRADIENT_PRESETS) as PlaybookGradient[];

const isPreset = (value: string): value is PlaybookGradient =>
  value in GRADIENT_PRESETS;

export const resolveBackground = (
  gradient?: PlaybookGradient | (string & {}),
): string => {
  if (!gradient) return GRADIENT_PRESETS.default;
  return isPreset(gradient) ? GRADIENT_PRESETS[gradient] : gradient;
};
